<div style="margin: 30px 0">
  @if (viewDataObservable | async; as viewData) {
    @if (viewData.tilintarkastusDone) {
      @if (viewData.tilinpaatosSigned) {
        @if (viewData.mode === 'edit') {
          <div>{{ 'reports-lemonaid.voit-luoda-ja-allekirjoittaa' | translate | async }}</div>
          <form>
            <div class="heading light-blue-text">{{ 'reports-lemonaid.perustiedot' | translate | async }}</div>
            <div style="display: flex; flex-direction: row; flex-wrap: wrap">
              <mat-form-field style="width: 245px; margin-right: 10px">
                <mat-label>{{ 'reports-lemonaid.kokouksen-aika' | translate | async }}</mat-label>
                <input matInput [matDatepicker]="picker" [formField]="lomake.meetingDate" />
                @if (onkoVirhe(lomake.meetingDate, 'minDate') && (lomake.meetingDate().dirty() || lomake.meetingDate().touched())) {
                  <mat-error>{{ 'reports-lemonaid.kokouksen-aika-min-date' | translate | async }}</mat-error>
                }
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
              </mat-form-field>
              <div class="time-container">
                <mat-form-field style="width: 30px">
                  <input #startHours timeFormat [timeType]="'hours'" class="time-input" maxlength="2" type="text" [formField]="lomake.meetingHours" matInput autocomplete="kirjnpitomekiarki" cdkFocusInitial />
                </mat-form-field>
                <div class="sep-colon">:</div>
                <mat-form-field style="width: 30px">
                  <input timeFormat [timeType]="'minutes'" class="time-input" maxlength="2" type="text" [formField]="lomake.meetingMinutes" matInput autocomplete="kirjnpitomekiarki" />
                </mat-form-field>
              </div>
              <mat-form-field style="width: 245px; margin-right: 20px">
                <mat-label>{{ 'reports-lemonaid.kokouspaikka' | translate | async }}</mat-label>
                <input matInput [formField]="lomake.kokouspaikka" />
                <mat-hint>{{ 'reports-lemonaid.kokouspaikka-esimerkki' | translate | async }}</mat-hint>
              </mat-form-field>
              <mat-form-field style="max-width: 180px; margin-right: 20px">
                <mat-label>{{ 'reports-lemonaid.poytakirjan-numero' | translate | async }}</mat-label>
                <input matInput [formField]="lomake.poytakirjanNumero" />
              </mat-form-field>
            </div>
            <div class="heading light-blue-text">{{ 'reports-lemonaid.lasnaolijat' | translate | async }}</div>
            <table class="lasnaolijat-table">
              <thead>
                <tr class="light-gray-text">
                  <th>{{ 'reports-lemonaid.nimi' | translate | async }}</th>
                  <th>{{ 'reports-lemonaid.osakkeet' | translate | async }}</th>
                </tr>
              </thead>
              <tbody>
                @for (lasnaolija of lomake.lasnaolijat; track lasnaolija) {
                  <tr>
                    <td>
                      <mat-checkbox [formField]="lasnaolija.selected">{{ lasnaolija.name().value() }}</mat-checkbox>
                    </td>
                    <td>{{ lasnaolija.osakkeita().value() }}</td>
                  </tr>
                }
              </tbody>
            </table>
            <div class="heading light-blue-text">{{ 'reports-lemonaid.kokouksen-avaus' | translate | async }}</div>
            <div class="small-header">{{ 'reports-lemonaid.kokouksen-avasi' | translate | async }}</div>
            <mat-radio-group style="display: flex; flex-direction: column" [formField]="lomake.kokouksenAvasi">
              @for (user of selectedParticipants(); track user) {
                <mat-radio-button [value]="user.name">
                  {{ user.name }}
                </mat-radio-button>
              }
            </mat-radio-group>
            <div class="heading light-blue-text">{{ 'reports-lemonaid.kokouksen-jarjestaytyminen' | translate | async }}</div>
            <div class="signer-roles">
              <div style="margin-right: 100px">
                <div class="small-header">{{ 'reports-lemonaid.puheenjohtaja' | translate | async }}</div>
                <mat-radio-group style="display: flex; flex-direction: column" [formField]="lomake.puheenjohtaja">
                  @for (user of selectedParticipants(); track user) {
                    <mat-radio-button [value]="user" [disabled]="!user?.lemonaidUid">
                      {{ user.name }}
                    </mat-radio-button>
                  }
                </mat-radio-group>
              </div>
              <div style="margin-right: 100px">
                <div class="small-header">{{ 'reports-lemonaid.poytakirjan-tarkastaja' | translate | async }}</div>
                <mat-radio-group style="display: flex; flex-direction: column" [formField]="lomake.poytakirjanTarkastaja">
                  @for (user of selectedParticipants(); track user) {
                    <mat-radio-button [value]="user" [disabled]="!user?.lemonaidUid">
                      {{ user.name }}
                    </mat-radio-button>
                  }
                </mat-radio-group>
              </div>
            </div>
            @if (usersWithoutLemonaidAccountSelected()) {
              <div style="margin-top: 10px; font-size: 12px">{{ 'reports-lemonaid.henkiloita-ei-voi-valita' | translate | async }}</div>
            }
            <div class="heading light-blue-text">{{ 'reports-lemonaid.osinkojen-jakaminen' | translate | async }}</div>
            <mat-radio-group style="display: flex; flex-direction: column" [formField]="lomake.osinkojaJaetaan">
              <mat-radio-button [value]="false"> {{ 'reports-lemonaid.osinkoa-ei-jaeta' | translate | async }} </mat-radio-button>
              @if (osinkojaJaetaanYhteensaObservable | async; as osinkoSumAsString) {
                <mat-radio-button [value]="true">
                  <div style="white-space: pre-wrap">{{ 'reports-lemonaid.osinkoa-jaetaan' | translate: { sum: osinkoSumAsString } | async }}</div>
                </mat-radio-button>
              }
            </mat-radio-group>
          </form>
          <div class="button-container">
            <button mat-button class="primarybutton" style="padding-left: 1rem; padding-right: 1rem" (click)="createPreviewMoveToSigning()">{{ 'reports-lemonaid.esikatsele-ja-allekirjoita' | translate | async }}</button>
          </div>
          @if (commonError()) {
            <div class="red-text common-error" style="margin-top: 20px; text-align: center">{{ commonError() }}</div>
          }
        }
        @if (viewData.mode === 'view') {
          <div>
            @if (viewData.pdfPages?.length) {
              <button mat-button class="secondarybutton" style="margin: 25px" (click)="downloadPdf()">{{ 'reports-lemonaid.lataa-asiakirja' | translate | async }}</button>
            }
            @for (page of viewData.pdfPages; track page) {
              <div class="lemon-mat-elevation-z4" style="margin: 1em">
                @if (page.getImageObservable() | async; as kuva) {
                  <img [src]="kuva" style="width: 100%" />
                } @else {
                  <div style="text-align: center; padding: 50px 0">
                    <mat-spinner style="display: inline-block"></mat-spinner>
                  </div>
                }
              </div>
            }
            @if (viewData.ptkirjaMissingSignatures) {
              <div>
                <div class="heading light-blue-text">{{ 'reports-lemonaid.allekirjoitukset' | translate | async }}</div>
                <div class="btn-on-right-container">
                  <button mat-button class="gray-text-btn" (click)="editPoytakirja()">{{ 'reports-lemonaid.muokkaa-poytakirjaa' | translate | async }}</button>
                </div>
                <div class="signers-container">
                  @for (signer of signers(); track signer) {
                    <div class="signer-box">
                      <!-- Top text if signed -->
                      @if (!!signer.signedAt) {
                        <div>
                          <div style="display: flex; flex-direction: row; color: gray">
                            <mat-icon style="font-size: 40px; width: 2.5rem; height: 2.5rem">lock</mat-icon>
                            <div>
                              <div>{{ 'reports-lemonaid.allekirjoitettu-sahkoisesti' | translate | async }}</div>
                              <div>{{ signer.name }} {{ signer.signedAt | ltimestamp | async }}</div>
                            </div>
                          </div>
                        </div>
                      }
                      <!-- Top text if not signed and current user -->
                      @if (!signer.signedAt && signer.isCurrentUser) {
                        <div>
                          <div style="display: flex; flex-direction: row; color: gray">
                            <button mat-button class="primarybutton" style="padding-left: 1rem; padding-right: 1rem" (click)="saveSignature()">{{ 'reports-lemonaid.allekirjoita' | translate | async }}</button>
                          </div>
                        </div>
                      }
                      <!-- Top text if not signed and not current user -->
                      @if (!signer.signedAt && !signer.isCurrentUser) {
                        <div>
                          <div style="display: flex; flex-direction: row; color: gray; height: 44px; align-items: center">
                            <div class="red-text">{{ 'reports-lemonaid.allekirjoitus-puuttuu' | translate | async }}</div>
                          </div>
                        </div>
                      }
                      <!-- Border and underline text -->
                      <div class="underline-info">
                        <div>{{ signer.name }}</div>
                        <div style="white-space: pre-wrap">{{ signer.rolesLocalized }}</div>
                      </div>
                    </div>
                  }
                </div>
              </div>
            }
          </div>
        }
      } @else {
        <div style="text-align: center; padding: 50px 0">
          <div style="text-align: center; padding: 20px 0">{{ 'reports-lemonaid.ei-tilitarkasteta.tilinpaatos-pitaa-allekirjoittaa' | translate | async }}</div>
        </div>
      }
    } @else {
      <div style="text-align: center; padding: 50px 0">
        <div style="text-align: center; padding: 20px 0">{{ 'reports-lemonaid.tilitarkastetaan.tilinpaatos-pitaa-tilintarkastaa' | translate | async }}</div>
      </div>
    }
  } @else {
    <div style="text-align: center; padding: 50px 0">
      <mat-spinner style="display: inline-block"></mat-spinner>
      <div style="text-align: center; padding: 20px 0">{{ 'reports-lemonaid.yhtiokokouksen-poytakirjan-tietoja-ladataan' | translate | async }}</div>
    </div>
  }
</div>

<ng-template #loadingdocument>
  <div style="text-align: center; padding: 50px 0">
    <mat-spinner style="display: inline-block"></mat-spinner>
    <div style="text-align: center; padding: 20px 0">{{ 'reports-lemonaid.yhtiokokouksen-poytakirjaa-ladataan' | translate | async }}</div>
  </div>
</ng-template>
